import { createPersistedState } from '@edreamsodigeo/frontend-core';

import type { UsePersistedState } from './types';

export const persistedPrimeDecouplingPIT = (): UsePersistedState => {
  return createPersistedState({
    type: 'sessionStorage',
    key: 'primeDecouplingPitToken',
    isGlobal: true,
  });
};
